var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "22px",
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pinMap") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pinMap",
    transform: "translate(1.000000, 1.000000)",
    stroke: "white",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,11 C9.657,11 11,9.657 11,8 C11,6.343 9.657,5 8,5 C6.343,5 5,6.343 5,8 C5,9.657 6.343,11 8,11 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,20 C12,16 16,12.418 16,8 C16,3.582 12.418,0 8,0 C3.582,0 0,3.582 0,8 C0,12.418 4,16 8,20 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinMap);
export default __webpack_public_path__ + "static/media/pinMap.33668712a9b316ab330e4b79a987ac4e.svg";
export { ForwardRef as ReactComponent };